if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        // Delegated so listeners survive innerHTML replacement after section re-renders
        this.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
      }

      get appliedCodes() {
        return Array.from(this.querySelectorAll('[data-discount-code]')).map((pill) => pill.dataset.discountCode);
      }

      onSubmit(event) {
        event.preventDefault();
        const input = this.querySelector('input[name="discount"]');
        const code = input.value.trim();
        if (!code) return;

        if (this.appliedCodes.some((applied) => applied.toLowerCase() === code.toLowerCase())) {
          input.value = '';
          return;
        }

        const previousCodes = this.appliedCodes;
        this.toggleLoading(true);
        this.toggleError(false);

        this.updateCart([...previousCodes, code])
          .then((state) => {
            const entry = (state.discount_codes || []).find(
              (discount) => discount.code.toLowerCase() === code.toLowerCase()
            );
            if (!entry || !entry.applicable) {
              return this.updateCart(previousCodes).then((rollbackState) => {
                this.renderSections(rollbackState);
                this.toggleError(true);
              });
            }
            input.value = '';
            this.renderSections(state);
            this.publishUpdate(state);
          })
          .catch(() => this.toggleError(true))
          .finally(() => this.toggleLoading(false));
      }

      onClick(event) {
        const removeButton = event.target.closest('[data-remove-discount]');
        if (!removeButton) return;
        const codeToRemove = removeButton.closest('[data-discount-code]').dataset.discountCode;
        const remainingCodes = this.appliedCodes.filter((code) => code !== codeToRemove);

        this.toggleLoading(true);
        this.toggleError(false);

        this.updateCart(remainingCodes)
          .then((state) => {
            this.renderSections(state);
            this.publishUpdate(state);
          })
          .catch(() => this.toggleError(true))
          .finally(() => this.toggleLoading(false));
      }

      updateCart(codes) {
        const body = JSON.stringify({
          discount: codes.join(','),
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body }).then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        });
      }

      getSectionsToRender() {
        const sections = [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
        const cartItems = document.getElementById('main-cart-items');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartItems) sections.push({ id: 'main-cart-items', section: cartItems.dataset.id, selector: '.js-contents' });
        if (cartFooter) {
          sections.push({ id: 'main-cart-footer', section: cartFooter.dataset.id, selector: '.js-contents' });
        }
        if (document.querySelector('cart-drawer')) {
          sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
        }
        return sections;
      }

      renderSections(state) {
        const footerSelf = this.closest('#main-cart-footer');
        this.getSectionsToRender().forEach(({ id, section, selector }) => {
          const sectionHtml = state.sections && state.sections[section];
          const container = document.getElementById(id);
          if (!sectionHtml || !container) return;
          const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const source = parsed.querySelector(selector);
          const target = container.querySelector(selector) || container;
          if (source) target.innerHTML = source.innerHTML;
          if (footerSelf && id === 'main-cart-footer') {
            const updatedSelf = parsed.querySelector('cart-discount');
            if (updatedSelf) this.innerHTML = updatedSelf.innerHTML;
          }
        });
      }

      publishUpdate(state) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: state });
        }
      }

      toggleLoading(loading) {
        const button = this.querySelector('.cart-discount__button');
        button.disabled = loading;
        button.querySelector('.loading__spinner').classList.toggle('hidden', !loading);
        button.querySelector('.cart-discount__button-text').classList.toggle('visibility-hidden', loading);
      }

      toggleError(show) {
        this.querySelector('.cart-discount__error').toggleAttribute('hidden', !show);
      }
    }
  );
}
